// <img> wrapper that loads a Bearer-authed image via blob URL. Used for
// inline images in rich descriptions/comments where we can't put the
// auth token on the raw <img src> attribute.
//
// Lifecycle: on mount, fetch the bytes through api.fetchAttachmentBlobUrl
// (which sends Authorization: Bearer …), turn the blob into an object URL,
// render. On unmount or id change, revoke the URL.

import { useEffect, useState } from 'react';
import * as api from '../lib/api.ts';

export const AuthImage = ({ attachmentId, alt = '', className = '', style, onClick }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let currentUrl = null;
    setUrl(null); setErr(null);
    api.fetchAttachmentBlobUrl(attachmentId)
      .then(u => {
        if (cancelled) { URL.revokeObjectURL(u); return; }
        currentUrl = u;
        setUrl(u);
      })
      .catch(e => { if (!cancelled) setErr(e.message || '加载失败'); });
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [attachmentId]);

  if (err) {
    return (
      <span className={`auth-image-error ${className}`} title={err}>
        🖼️ 图片加载失败
      </span>
    );
  }
  if (!url) {
    return <span className={`auth-image-loading ${className}`}>🖼️ …</span>;
  }
  return (
    <img src={url} alt={alt} className={`auth-image ${className}`}
         style={style} onClick={onClick} />
  );
};
